// Reference: https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override

export const stylesGlobal = {
	/*=====
		ReactTable (material-react-table)
	=====*/
	".reactTable .MuiCollapse-root.MuiCollapse-vertical": {
		height: "50px",
	},
	// fullscreen mode not in front of main navbars
	".reactTable .MuiPaper-root[style]": {
		zIndex: "9999 !important",
	},
	// no padding on table footer
	".reactTable .MuiTablePagination-root.MuiBox-root": {
		padding: "0 10px !important",
	},
	".reactTable .MuiIconButton-root ": {
		padding: "4px",
	},
	// hide/show columns toggle buttons, no spacing around buttons
	".MuiPaper-root.MuiPaper-elevation.MuiPopover-paper.MuiMenu-paper .MuiList-root.MuiList-padding.MuiMenu-list .MuiBox-root .MuiButtonBase-root.MuiButton-root": {
		margin: "0 2px",
	},
};
